import React from "react";

import { HashRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./Home";
import Contact from "./Contact";
import Mapview from "./Mapview"; 
import PrivateRoute from "./PrivateRoute";
import HeroSection from "./HeroSection";
import Admin from "./Admin";
import AdminRoute from "./AdminRoute";


function App() {

  
  return (
     <Router>
      <Routes>

        <Route path="/" element={<PrivateRoute>
              <Mapview />
            </PrivateRoute>} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Admin />
            </AdminRoute>
          }
        />
        <Route 
          path="/Mapview" 
          element={
            <PrivateRoute>
              <Mapview />
            </PrivateRoute>
          } 
        />
        
        <Route path="/Contact" element={<Contact />}  />
        <Route path="/page accueil" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
